(() => {
  const exactMessage = 'saisir un code de réduction valide';
  const normalize = (value) => value.replace(/\s+/g, ' ').trim().toLocaleLowerCase('fr');

  const hideIfExactMessage = (element) => {
    if (!(element instanceof HTMLElement)) return;

    if (element.childElementCount === 0 && normalize(element.textContent || '') === exactMessage) {
      element.hidden = true;
      element.setAttribute('aria-hidden', 'true');
      return;
    }

    if (
      element instanceof HTMLInputElement &&
      normalize(element.getAttribute('placeholder') || '') === exactMessage
    ) {
      element.removeAttribute('placeholder');
    }

    if (normalize(element.getAttribute('title') || '') === exactMessage) {
      element.removeAttribute('title');
    }
  };

  const scan = (root) => {
    if (!(root instanceof Element || root instanceof Document)) return;
    hideIfExactMessage(root);
    root.querySelectorAll('*').forEach(hideIfExactMessage);
  };

  scan(document);

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'characterData') {
        scan(record.target.parentElement || document);
      }

      if (record.type === 'attributes') {
        hideIfExactMessage(record.target);
      }

      record.addedNodes.forEach((node) => {
        if (node instanceof Element) {
          scan(node);
        } else if (node instanceof Text) {
          scan(node.parentElement || document);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['placeholder', 'title'],
    subtree: true
  });
})();